/* unplugin-vue-components disabled */import { render } from "./Catalog2.vue?vue&type=template&id=215bed0c&scoped=true"
import script from "./Catalog2.vue?vue&type=script&lang=js"
export * from "./Catalog2.vue?vue&type=script&lang=js"

import "./Catalog2.vue?vue&type=style&index=0&id=215bed0c&scoped=true&lang=css"

import exportComponent from "/home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-215bed0c"]])

export default __exports__